import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import { Modal } from "antd";
import $axios from "./services/axios";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyToken =
    queryParams.get("VerifyToken") || queryParams.get("verifyToken");
  const [token, setToken] = useState(
    verifyToken
      ? null
      : localStorage.getItem("servicePaymentToken")
  );
  const history = useHistory();
  const location = useLocation();

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (
        verifyToken ||
        localStorage.getItem("servicePaymentToken")
      ) {
        if (verifyToken) {
          const res = await $axios.$post("/login", {
            VerifyToken: verifyToken,
          });
          localStorage.setItem("servicePaymentToken", res.data.data.token);
          console.log(res,'res');
          
          const userInfo = res?.data?.data?.userInfo;
          userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          setToken(res.data.data.token);
          queryParams.delete("VerifyToken");
          history.replace({
            pathname: location.pathname,
            search: queryParams.toString(),
          });
        }
      } else {
        modal.error(config);
      }
    } catch (error) {}
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/service-payment"} />
        <Route
          exact
          path={"/service-payment"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Redirect to={"/service-payment"} />
      </Switch>
      {contextHolder}
    </>
  );
};
export default App;
